// extracted by mini-css-extract-plugin
module.exports = {"reviewForm":"_3U7Kq","heading":"_3D3F8","rattingWrapper":"AR79S","rattingCard":"N3Z7S","uploadFile":"_37wqN","reviewSubmitForm":"_15E8u","feedbackSubmit":"_2BzbZ"};